import React from "react"; //create a global context of the current call object in use, connected to a meeting room url

export default React.createContext();
